import requests from './httpService';
const FeeService = {

  getAllFee(id) {
    return requests.get(`/fee/list/${id}`);
  },

  creteFee(body){
    return requests.post('/fee/add',body); 
  },
  deleteFee(body){
    return requests.delete(`/fee/${body._id}`); 
  },
  findFeeList(body){
    return requests.post(`/fee/find`,body); 
  },
  upadeFee(body) {
    return requests.put(`/fee/${body._id}`,body); 
  },
  updateInstallmentPaymentStatus(id, paymentStatus) {
    return requests.put(`/fee/installment/${id}/status`, { paymentStatus });
  },
}


export default FeeService;
